import { render, staticRenderFns } from "./SettingAccounts.vue?vue&type=template&id=2f2a4a4d"
import script from "./SettingAccounts.vue?vue&type=script&lang=js"
export * from "./SettingAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports